import { Tag } from '@veneer/core';
import tokens from '@veneer/tokens';
import { Card } from '@uma/react-commons/dist/index';
import styled from 'styled-components';

export const OfferStyledCard = styled(Card)`
  &:hover {
    cursor: pointer;
    border-color: ${tokens.color.gray8};
  }
  &:focus-visible {
    outline-offset: -2px !important;
  }
`;

export const OfferContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  gap: ${tokens.layout.size2};
`;

export const OfferTitle = styled.h2`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const OfferDescription = styled.p`
  color: ${tokens.color.gray9};
`;

export const OfferTag = styled(Tag)`
  && {
    width: fit-content;
    background-color: #e4eefa; // Color currently not defined in Tokens
    color: ${tokens.color.gray9};

    .label-small {
      font-size: ${tokens.typography.size1};
    }
  }
`;

export const OfferCTA = styled.div`
  display: flex;
  margin-top: ${tokens.layout.size4};
`;

export const OfferLink = styled.a`
  color: #024ad8; // Color currently not defined in Tokens
  cursor: pointer;

  :hover {
    color: #0036c4; // Color currently not defined in Tokens
  }
  :active {
    color: #001cb0; // Color currently not defined in Tokens
  }
`;

export const OfferBackground = styled.div<{ $rtl?: boolean }>`
  background-color: #f5f5f5;
  border-radius: 12px;
  width: 120px;
  height: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${({ $rtl }) => ($rtl ? 'margin-right: 1px;' : 'margin-left: 1px;')}
`;

export const OfferImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const OfferPricing = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.layout.size1};
`;

export const OfferCurrentPrice = styled.span`
  color: ${tokens.color.gray9};
`;

export const OfferPriceBefore = styled.span`
  color: ${tokens.color.gray7};
  text-decoration: line-through;
`;
